import { render, staticRenderFns } from "./DeleteFileModal.vue?vue&type=template&id=17cd062f&scoped=true&"
import script from "./DeleteFileModal.vue?vue&type=script&lang=js&"
export * from "./DeleteFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cd062f",
  null
  
)

export default component.exports